import React from "react";
import moment from "moment";

const MessageTile = ({ message }) => {
  return (
    <div className="message-tile-container">
      <p>{message.message_content}</p>
      <span className="message-tile-date">
        {moment(message.created_at).format("MMM DD")}
      </span>
    </div>
  );
};

export default MessageTile;
